// Mirror of shared.jsx TROLY tokens — use in inline styles where needed
export const T = {
  teal:        '#45E6C2',
  tealBright:  '#2fedcd',
  tealDark:    '#0e9e82',
  tealGlow:    'rgba(69,230,194,0.12)',
  bg:          '#FAFAFA',
  surface:     '#FFFFFF',
  ink:         '#0A0A0A',
  ink80:       '#1F1F1F',
  muted:       '#6B6B6B',
  line:        '#E5E5E5',
  lineSoft:    '#EFEFEF',
  darkBg:      '#0A0A0A',
  darkSurface: '#151515',
  darkLine:    '#262626',
};

// Shared SVG icons — exact from shared.jsx
export const Icon = {
  search: (s=16) => (
    <svg width={s} height={s} viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round">
      <circle cx="9" cy="9" r="6"/><path d="M14 14l4 4"/>
    </svg>
  ),
  globe: (s=16) => (
    <svg width={s} height={s} viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5">
      <circle cx="10" cy="10" r="7.5"/><path d="M2.5 10h15M10 2.5c2.5 3 2.5 12 0 15M10 2.5c-2.5 3-2.5 12 0 15"/>
    </svg>
  ),
  moon: (s=16) => (
    <svg width={s} height={s} viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round">
      <path d="M16 11.5A6.5 6.5 0 0 1 8.5 4 6.5 6.5 0 1 0 16 11.5Z"/>
    </svg>
  ),
  sun: (s=16) => (
    <svg width={s} height={s} viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round">
      <circle cx="10" cy="10" r="3.5"/>
      <path d="M10 2v2M10 16v2M2 10h2M16 10h2M4.2 4.2l1.5 1.5M14.3 14.3l1.5 1.5M4.2 15.8l1.5-1.5M14.3 5.7l1.5-1.5"/>
    </svg>
  ),
  home: (s=16) => (
    <svg width={s} height={s} viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 9l7-6 7 6v8a1 1 0 0 1-1 1h-4v-6H8v6H4a1 1 0 0 1-1-1V9Z"/>
    </svg>
  ),
  plus: (s=16) => (
    <svg width={s} height={s} viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
      <path d="M10 4v12M4 10h12"/>
    </svg>
  ),
  gear: (s=16) => (
    <svg width={s} height={s} viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5">
      <circle cx="10" cy="10" r="2.5"/>
      <path d="M10 2.5v2M10 15.5v2M2.5 10h2M15.5 10h2M4.6 4.6l1.4 1.4M14 14l1.4 1.4M4.6 15.4L6 14M14 6l1.4-1.4"/>
    </svg>
  ),
  eye: (s=14) => (
    <svg width={s} height={s} viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
      <path d="M1 8s2.5-4.5 7-4.5S15 8 15 8s-2.5 4.5-7 4.5S1 8 1 8Z"/><circle cx="8" cy="8" r="2"/>
    </svg>
  ),
  eyeOff: (s=14) => (
    <svg width={s} height={s} viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
      <path d="M2 2l12 12M6.5 6.5A2 2 0 0 0 9.5 9.5M1 8s2.5-4.5 7-4.5c1.2 0 2.3.3 3.2.7M15 8s-1 1.9-3 3.3"/>
    </svg>
  ),
  chevronDown: (s=12) => (
    <svg width={s} height={s} viewBox="0 0 12 12" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round">
      <path d="M3 4.5l3 3 3-3"/>
    </svg>
  ),
  folder: (s=14) => (
    <svg width={s} height={s} viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M2 5a1 1 0 0 1 1-1h3.5l1.5 2H13a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V5Z"/>
    </svg>
  ),
  shield: (s=26) => (
    <svg width={s} height={s} viewBox="0 0 28 28" fill="none" stroke="#45E6C2" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14 3l9 3v8c0 5-4 9-9 11-5-2-9-6-9-11V6l9-3Z"/><path d="M10 14l3 3 5-5"/>
    </svg>
  ),
  chart: (s=26) => (
    <svg width={s} height={s} viewBox="0 0 28 28" fill="none" stroke="#45E6C2" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 20l6-8 5 4 9-11"/>
      <circle cx="4" cy="20" r="1.2"/><circle cx="10" cy="12" r="1.2"/>
      <circle cx="15" cy="16" r="1.2"/><circle cx="24" cy="5" r="1.2"/>
    </svg>
  ),
  network: (s=26) => (
    <svg width={s} height={s} viewBox="0 0 28 28" fill="none" stroke="#45E6C2" strokeWidth="1.6" strokeLinecap="round">
      <circle cx="14" cy="14" r="3"/>
      <circle cx="4" cy="5" r="2"/><circle cx="24" cy="5" r="2"/>
      <circle cx="4" cy="23" r="2"/><circle cx="24" cy="23" r="2"/>
      <path d="M6 6l6 6M22 6l-6 6M6 22l6-6M22 22l-6-6"/>
    </svg>
  ),
  cloud: (s=26) => (
    <svg width={s} height={s} viewBox="0 0 32 32" fill="none" stroke="#45E6C2" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M8 22h17a5 5 0 0 0 0-10 7 7 0 0 0-13.5-2A5 5 0 0 0 8 22Z"/>
      <path d="M16 18v-6M13 15l3-3 3 3"/>
    </svg>
  ),
  trendUp: (s=12) => (
    <svg width={s} height={s} viewBox="0 0 12 12" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round">
      <path d="M2 8l3-3 2 2 3-4"/><path d="M7 3h3v3"/>
    </svg>
  ),
  userPlus: (s=14) => (
    <svg width={s} height={s} viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round">
      <circle cx="8" cy="7" r="3"/><path d="M2.5 17c0-3 2.5-5 5.5-5s5.5 2 5.5 5M15 5v4M13 7h4"/>
    </svg>
  ),
  message: (s=16) => (
    <svg width={s} height={s} viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H9l-4 3v-3H5a2 2 0 0 1-2-2V5Z"/>
    </svg>
  ),
  sliders: (s=14) => (
    <svg width={s} height={s} viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round">
      <path d="M3 5h10M17 5h0M3 10h4M11 10h6M3 15h10M17 15h0"/>
      <circle cx="14" cy="5" r="1.8"/><circle cx="9" cy="10" r="1.8"/><circle cx="14" cy="15" r="1.8"/>
    </svg>
  ),
  camera: (s=14) => (
    <svg width={s} height={s} viewBox="0 0 16 16" fill="none" stroke="#45E6C2" strokeWidth="1.5" strokeLinecap="round">
      <path d="M2 5h3l1-1.5h4L11 5h3v8H2V5Z"/><circle cx="8" cy="9" r="2.5"/>
    </svg>
  ),
  doc: (s=14) => (
    <svg width={s} height={s} viewBox="0 0 16 16" fill="none" stroke="#45E6C2" strokeWidth="1.5" strokeLinecap="round">
      <path d="M3 2h7l3 3v9H3V2Z"/><path d="M10 2v3h3M5 8h6M5 10.5h6M5 13h4"/>
    </svg>
  ),
  swap: (s=16) => (
    <svg width={s} height={s} viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 7h13l-3.5-3.5M17 13H4l3.5 3.5"/>
    </svg>
  ),
  share: (s=16) => (
    <svg width={s} height={s} viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="15" cy="4.5" r="2.2"/><circle cx="5" cy="10" r="2.2"/><circle cx="15" cy="15.5" r="2.2"/>
      <path d="M7 8.9l6-3.3M7 11.1l6 3.3"/>
    </svg>
  ),
  link: (s=16) => (
    <svg width={s} height={s} viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <path d="M8.5 11.5a3 3 0 0 0 4.2 0l2.4-2.4a3 3 0 0 0-4.2-4.2l-1 1"/>
      <path d="M11.5 8.5a3 3 0 0 0-4.2 0l-2.4 2.4a3 3 0 0 0 4.2 4.2l1-1"/>
    </svg>
  ),
  mail: (s=16) => (
    <svg width={s} height={s} viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2.5" y="4.5" width="15" height="11" rx="2"/><path d="M3 5.5l7 5 7-5"/>
    </svg>
  ),
  whatsapp: (s=16) => (
    <svg width={s} height={s} viewBox="0 0 20 20" fill="currentColor" role="presentation">
      <path d="M10 1.7a8.2 8.2 0 0 0-7 12.5L1.7 18.3l4.2-1.3A8.2 8.2 0 1 0 10 1.7Zm0 1.6a6.6 6.6 0 1 1-3.5 12.2l-.3-.2-2.5.8.8-2.4-.2-.3A6.6 6.6 0 0 1 10 3.3Zm-2.9 3c-.2 0-.4 0-.6.3-.2.2-.8.8-.8 1.9 0 1.1.8 2.2.9 2.3.1.2 1.5 2.4 3.7 3.3 1.8.7 2.2.6 2.6.5.4 0 1.3-.5 1.5-1.1.2-.5.2-1 .1-1.1l-.5-.3-1.3-.6c-.2 0-.3-.1-.5.1l-.7.9c-.1.2-.3.2-.5.1-.2-.1-.9-.4-1.8-1.1-.6-.6-1.1-1.3-1.2-1.5-.1-.2 0-.3.1-.4l.4-.4c.1-.2.2-.3.2-.4l.1-.4-.6-1.5c-.2-.4-.3-.4-.5-.4h-.6Z"/>
    </svg>
  ),
  facebook: (s=16) => (
    <svg width={s} height={s} viewBox="0 0 20 20" fill="currentColor" role="presentation">
      <path d="M11.6 18v-7h2.3l.4-2.7h-2.7V6.6c0-.8.2-1.3 1.3-1.3h1.4V2.9c-.2 0-1.1-.1-2.1-.1-2.1 0-3.5 1.3-3.5 3.6v2h-2.3V11h2.3v7h2.9Z"/>
    </svg>
  ),
  verified: (s=14) => (
    <svg width={s} height={s} viewBox="0 0 16 16" fill="none" stroke="#C8A55B" strokeWidth="1.5" strokeLinecap="round">
      <path d="M8 1.5l1.8 1.4 2.3-.2.5 2.2 1.9 1.3-1 2 1 2-1.9 1.3-.5 2.2-2.3-.2L8 14.5l-1.8-1.4-2.3.2-.5-2.2L1.5 9.8l1-2-1-2 1.9-1.3.5-2.2 2.3.2L8 1.5Z"/>
      <path d="M5.5 8l1.7 1.7L11 6"/>
    </svg>
  ),
};
